// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useState } from 'react';
import { t } from 'i18next';
import { useParams } from 'react-router-dom';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { getAnalyticsFlowName, MoveMoneyTypes, successContentMap } from '../../consts';
import NoticeModal from '../../../../DesignSystem/NoticeModal/NoticeModal';
import { ReactComponent as AnnouncementIcon } from '../../../../assets/icons/svg/colored-icons/ic-colored-announcement.svg';
import { trackMixPanel } from '../../../../services/mixpanel.service';
import { LiliTextInput } from '../../../../DesignSystem/LiliTextInput/LiliTextInput';
import { ValidateFieldTypes, validateScheme } from '../../../../helpers/inputUtils.helper';
import { useStore } from '../../../../store';

interface BillNotifyVendorFooterProps {
  handleDone: () => void,
  onSendVendorNotificationClick: (newEmail: string) => void,
}

export const BillNotifyVendorFooter = (props: BillNotifyVendorFooterProps) => {
  const {
    handleDone, onSendVendorNotificationClick,
  } = props;
  const { moveType } = useParams();

  const moveMoneyData = useStore((state) => state.moveMoneyData);
  const [isShowNotifyVendorModal, setShowNotifyVendorModal] = useState<boolean>(false);
  const [notifyVendorEmail, setNotifyVendorEmail] = useState<string>(moveMoneyData.vendorData?.email || '');
  const [isValid, setIsValid] = useState(true);
  const [emailErrorMessage, setEmailErrorMessage] = useState<string>('');
  const isLoadingAndDisabled = false;

  const onSubmitClicked = () => {
    if (!isValid) return;
    onSendVendorNotificationClick(notifyVendorEmail);
  };

  const onEmailChange = (newEmail: string) => {
    setNotifyVendorEmail(newEmail);
    if (validateScheme(newEmail, ValidateFieldTypes.EMAIL)) {
      setIsValid(true);
      setEmailErrorMessage('');
    } else {
      setIsValid(false);
    }
  };

  return (
    <>
      <LiliButton
        type={LiliButtonType.SECONDARY}
        onClick={handleDone}
        id='continue'
        className='w-[226px]'
        title={t(successContentMap[moveType as keyof typeof successContentMap].main_cta)}
      />
      <LiliButton
        onClick={() => {
          trackMixPanel('Act on Move Money Confirmation Screen', { Flow: getAnalyticsFlowName(moveType as MoveMoneyTypes), Action: 'Notify Vendor' });
          setShowNotifyVendorModal(true);
        }}
        isLoading={isLoadingAndDisabled}
        disabled={isLoadingAndDisabled}
        id='notifyVendor'
        className='w-[226px]'
        title={t(successContentMap[moveType as keyof typeof successContentMap].notify_vendor)}
      />
      {isShowNotifyVendorModal && (
        <NoticeModal
          title={t('MOVE_MONEY.STEPS.SUCCESS.NOTIFY_VENDOR.TITLE')}
          id='vendorEmailInputModal'
          image={<AnnouncementIcon />}
          content={(
            <>
              <p className='text-[16px] text-bw07 font-metricR text-center mb-[32px]'>{t('MOVE_MONEY.STEPS.SUCCESS.NOTIFY_VENDOR.SUB_TITLE') as string}</p>
              <LiliTextInput
                id='vendorEmailInputField'
                title={t('MOVE_MONEY.STEPS.SUCCESS.NOTIFY_VENDOR.VENDORS_EMAIL')}
                value={notifyVendorEmail}
                type='email'
                errorMessage={emailErrorMessage}
                onChange={onEmailChange}
                onBlur={() => {
                  const isNewEmailValid = validateScheme(notifyVendorEmail, ValidateFieldTypes.EMAIL);
                  setIsValid(isNewEmailValid);
                  setEmailErrorMessage(isNewEmailValid || notifyVendorEmail === '' ? '' : t('MOVE_MONEY.STEPS.SUCCESS.NOTIFY_VENDOR.INVALID_EMAIL'));
                }}
              />
            </>
          )}
          buttonText={t('MOVE_MONEY.STEPS.SUCCESS.NOTIFY_VENDOR.CTA')}
          onSubmit={onSubmitClicked}
          onClickOutside={() => setShowNotifyVendorModal(false)}
          secondaryButtonText={t('MOVE_MONEY.STEPS.SUCCESS.NOTIFY_VENDOR.SECONDARY_CTA')}
          submitButtonProps={{
            disabled: !isValid,
          }}
        />
      )}
    </>
  );
};
